module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "claimDetail"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "main claim"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._m(0), _vm._v(" "), (_vm.obj.claimState == 0) ? _c('div', {
    staticClass: "logo"
  }) : _vm._e(), _vm._v(" "), (_vm.obj.claimState == 2) ? _c('div', {
    staticClass: "logo_success"
  }) : _vm._e(), _vm._v(" "), (_vm.obj.claimState == 1) ? _c('div', {
    staticClass: "logo_failed"
  }) : _vm._e()])]), _vm._v(" "), (_vm.obj.claimState == 0) ? _c('div', {
    attrs: {
      "id": "claimPage"
    }
  }, [_c('p', {
    staticClass: "limit"
  }, [_vm._v("参保用户赔偿额度")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("\n        索赔流程:\n        "), _c('router-link', {
    attrs: {
      "to": "/new/claimFlow"
    }
  }, [_vm._v("查看详情")])], 1), _vm._v(" "), _c('p', {
    staticClass: "bb"
  }, [_vm._v("\n        索赔资料:\n        "), _c('router-link', {
    attrs: {
      "to": "/new/docs"
    }
  }, [_vm._v("查看详情")])], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.obj.claimState == 2) ? _c('div', {
    attrs: {
      "id": "claimSuccessPage"
    }
  }, [_c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("\n        索赔人:\n        "), _c('span', {
    attrs: {
      "id": "username"
    }
  }, [_vm._v(_vm._s(_vm.obj.userName))])]), _vm._v(" "), _c('p', {
    staticClass: "bb"
  }, [_vm._v("\n        索赔金额:\n        "), _c('span', {
    attrs: {
      "id": "price"
    }
  }, [_vm._v("￥" + _vm._s(_vm.obj.claimMoney))])]), _vm._v(" "), _c('p', [_vm._v("\n        银行卡号:\n        "), _c('span', {
    attrs: {
      "id": "bankCard"
    }
  }, [_vm._v(_vm._s(_vm.obj.blankCard))])])]), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("\n        索赔开始时间:\n        "), _c('span', {
    attrs: {
      "id": "startDate"
    }
  }, [_vm._v(_vm._s(_vm.obj.startDate))])]), _vm._v(" "), _c('p', [_vm._v("\n        索赔结束时间:\n        "), _c('span', {
    attrs: {
      "id": "endDate"
    }
  }, [_vm._v(_vm._s(_vm.obj.endDate))])])]), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    attrs: {
      "id": "reason"
    }
  }, [_c('span', {
    staticStyle: {
      "position": "static"
    }
  }, [_vm._v("备注:" + _vm._s(_vm.obj.dec))])])])]) : _vm._e(), _vm._v(" "), (_vm.obj.claimState == 1) ? _c('div', {
    attrs: {
      "id": "claimFailedPage"
    }
  }, [_c('div', {
    staticClass: "block clearfix"
  }, [_c('p', [_vm._v("\n        索赔人:\n        "), _c('span', {
    attrs: {
      "id": "username"
    }
  }, [_vm._v(_vm._s(_vm.obj.userName))])])]), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("\n        索赔开始时间:\n        "), _c('span', {
    attrs: {
      "id": "startDate"
    }
  }, [_vm._v(_vm._s(_vm.obj.startDate))])]), _vm._v(" "), _c('p', [_vm._v("\n        索赔结束时间:\n        "), _c('span', {
    attrs: {
      "id": "endDate"
    }
  }, [_vm._v(_vm._s(_vm.obj.endDate))])])]), _vm._v(" "), _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    attrs: {
      "id": "reason"
    }
  }, [_c('span', {
    staticStyle: {
      "position": "static"
    }
  }, [_vm._v("备注:" + _vm._s(_vm.obj.dec))])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "zhongan"
  }, [_vm._v("\n        WiFi安全险\n        "), _c('img', {
    attrs: {
      "src": require("../images/zhongan.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("\n        每一用户单日/单次索赔限额：\n        "), _c('span', [_vm._v("￥20,000元")])]), _vm._v(" "), _c('p', [_vm._v("\n        每一用户累计最高可赔：\n        "), _c('span', [_vm._v("￥100,000元")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        服务热线:\n        "), _c('a', {
    attrs: {
      "href": "tel:4009999595"
    }
  }, [_vm._v("400-999-9595")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block clearfix"
  }, [_c('p', {
    staticClass: "bb"
  }, [_vm._v("\n        索赔资料收件人:\n        "), _c('span', {
    staticClass: "small_font"
  }, [_vm._v("WiFi万能钥匙商户安全理赔项目组")])]), _vm._v(" "), _c('p', {
    staticClass: "bb"
  }, [_vm._v("\n        寄送地址:\n        "), _c('span', {
    staticClass: "small_font"
  }, [_vm._v("上海市浦东新区张衡路666弄1号楼7楼")])]), _vm._v(" "), _c('p', [_vm._v("\n        快递联系电话:\n        "), _c('span', [_vm._v("400-035-8000")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3975818a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/claimDetail.vue
// module id = 820
// module chunks = 1